import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import SplitPane from 'react-split-pane';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { touch, focus } from 'redux-form';

import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import * as userActions from 'modules/user';
import * as loginActions from 'modules/login';

import {
  CtAdminHeader,
  CtAdminMenu,
  CtAdminBasicConf,
  CtAdminSmtpConf,
  CtAdminExamTemplate,
  CtAdminExamAttach,
  CtAdminUser,
  CtAdminQna,
  CtAdminLicense,
  CtAdminLicenseConfig,
  CtAdminLog,
  CtAdminStatus,
  CtAdminApi,
  CtAdminTarget,
  CtPhishingTemplate,
  CtAdminSync,
  CtAdminEduTemplate
} from 'containers';

import { NotFoundPage } from 'pages';

const ScSection = styled.section`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const ScHeader = styled.header`
  height: 60px;
`;
const ScMain = styled.main`
  flex: 1;
  position: relative;
`;
const ScPage = styled.div`
  // padding: 25px;
  // background-color: #fafafa;
  width: 100%;
  height: 100%;
`;
const ScFooter = styled.footer`
  height: 20px;
  display: none;
`;

class AdminMainPage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // 관리자 비밀번호 변경 주기 넘었을시 자동 튕김
    const { userData } = this.props;
    if (userData.modifyEpoch + 7776000 < common.nowEpoch()) {
      const { UserActions, LoginActions } = this.props;

      localStorage.removeItem('loginAdmin');
      localStorage.removeItem('loginUser');
      sessionStorage.removeItem('curUser');

      // 로그아웃 처리
      UserActions.logout();
      // 로그인 초기화
      LoginActions.setInitial();
    }

    window.addEventListener('click', this.catchEvent, false);
    window.addEventListener('keyup', this.catchEvent, false);

    // 모달 공통 validation 체크
    const { ReduxFormTouch, ReduxFormFocus } = this.props;
    window.markFieldValidate = (formStore, formName, fieldName) => {
      if (formStore && formStore && formStore.registeredFields) {
        if (!!fieldName) {
          if (formStore.registeredFields[fieldName].count > 0) {
            ReduxFormTouch(formName, fieldName);
            ReduxFormFocus(formName, fieldName);
          }
        } else {
          for (const field in formStore.registeredFields) {
            if (formStore.registeredFields.hasOwnProperty(field)) {
              if (formStore.registeredFields[field].count > 0) {
                ReduxFormTouch(formName, field);
                ReduxFormFocus(formName, field);
              }
            }
          }
        }
      }
    };
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.catchEvent, false);
    window.removeEventListener('keyup', this.catchEvent, false);
  }

  catchEvent = e => {
    // 세션시간 연장
    sessionStorage.setItem('accessTime', common.nowEpoch());

    if (commonVar.isGs === 1) {
      // 다중 로그인 방지
      if (
        !localStorage.getItem('loginAdmin') ||
        sessionStorage.getItem('curUser') !== localStorage.getItem('loginAdmin')
      ) {
        const { UserActions, LoginActions } = this.props;

        // 로그아웃 처리
        UserActions.initialStore();
        // 로그인 초기화
        LoginActions.setInitial();
      }
    } else if (!localStorage.getItem('loginAdmin')) {
      localStorage.removeItem('loginAdmin');
      localStorage.removeItem('loginUser');
      sessionStorage.removeItem('curUser');

      const { UserActions, LoginActions } = this.props;

      // 로그아웃 처리
      UserActions.initialStore();
      // 로그인 초기화
      LoginActions.setInitial();
    }
  };

  render() {
    const manageUrl = this.props.match.url;
    const { menuOpen } = this.props;
    const menuHideStyle = menuOpen ? { overflow: 'auto' } : { display: 'none' };
    const pane2Stype = { overflow: 'auto' };
    const paneStyle = {};

    return (
      <ScSection>
        <ScHeader>
          <CtAdminHeader />
        </ScHeader>
        <ScMain>
          <SplitPane
            split="vertical"
            defaultSize={200}
            minSize={150}
            maxSize={250}
            paneStyle={paneStyle}
            pane1Style={menuHideStyle}
            pane2Style={pane2Stype}>
            <CtAdminMenu />
            <ScPage>
              <Switch>
                <Route exact path={manageUrl} component={CtAdminBasicConf} />
                <Route exact path={manageUrl + '/basicconf'} component={CtAdminBasicConf} />
                <Route exact path={manageUrl + '/smtpconf'} component={CtAdminSmtpConf} />
                <Route exact path={manageUrl + '/examtemplate/examtemplateMail'} component={CtAdminExamTemplate} />
                <Route exact path={manageUrl + '/examtemplate/examtemplatePhishing'} component={CtPhishingTemplate} />
                <Route exact path={manageUrl + '/examtemplate/examtemplateAttach'} component={CtAdminExamAttach} />
                <Route exact path={manageUrl + '/edutemplate'} component={CtAdminEduTemplate} />                
                <Route exact path={manageUrl + '/user'} component={CtAdminUser} />
                <Route exact path={manageUrl + '/target'} component={CtAdminTarget} />
                <Route exact path={manageUrl + '/qna'} component={CtAdminQna} />
                <Route exact path={manageUrl + '/license'} component={CtAdminLicense} />
                <Route exact path={manageUrl + '/license/config'} component={CtAdminLicenseConfig} />
                <Route exact path={manageUrl + '/sync'} component={CtAdminSync} />
                <Route exact path={manageUrl + '/log'} component={CtAdminLog} />
                <Route path={manageUrl + '/status/:target'} render={() => <CtAdminStatus />} />
                <Route exact path={manageUrl + '/api'} render={() => <CtAdminApi />} />
                <Route component={NotFoundPage} />
              </Switch>
            </ScPage>
          </SplitPane>
        </ScMain>
        <ScFooter>{/**/}</ScFooter>
      </ScSection>
    );
  }
}

AdminMainPage.propTypes = {};
AdminMainPage.defaultProps = {};

const mapStateToProps = state => ({
  menuOpen: state.admin.get('menuOpen'),
  userData: state.user.get('user')
});

const mapDispatchToProps = dispatch => ({
  UserActions: bindActionCreators(userActions, dispatch),
  LoginActions: bindActionCreators(loginActions, dispatch),
  ReduxFormTouch: bindActionCreators(touch, dispatch),
  ReduxFormFocus: bindActionCreators(focus, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminMainPage);



// WEBPACK FOOTER //
// ./src/script/pages/AdminMainPage.js